import { render, staticRenderFns } from "./ReAddForm.vue?vue&type=template&id=723d564a&scoped=true"
import script from "./ReAddForm.vue?vue&type=script&lang=js"
export * from "./ReAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723d564a",
  null
  
)

export default component.exports